import API_URL from "../apiConfig";

// src/auth/providers.ts
export const OAUTH_PROVIDERS = [
  {
    name: 'Google',
    id: 'google',
    buttonText: 'Sign in with Google',
    authUrl: `${API_URL}/auth/google`,
    icon: '/images/google-logo.svg', // Path to icon asset
    enabled: true
  },
  {
    name: 'Microsoft',
    id: 'microsoft',
    buttonText: 'Sign in with Microsoft',
    authUrl: `${API_URL}/auth/microsoft`,
    icon: '/images/microsoft-logo.svg',
    enabled: true
  }
];
